<template>
  <v-container fluid>

    <UsedAlert :usedConfig="usedConfig">
    </UsedAlert>

    <v-row justify="center">
      <CustomerGroupImage :key="imageKey" :relativePath="editItem.Image" :size="200" editable
        @File="file => { editItem.newImage = file; handleFocus(true); }">
      </CustomerGroupImage>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.Id" :label="$t('servicesystem.common_objects.customer_group.number')"
          maxlength="100" :rules="[requiredRule]" :disabled="!isNew" :externaledit="isNew && editMode"
          :errormessages="usedConfig ? [usedConfig.message] : undefined" @DebouncedInput="checkCustomerGroupId"
          @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.Name" :label="$t('servicesystem.common_objects.customer_group.name')"
          maxlength="80" :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row v-if="!isNew"> <!-- No point in being able to create inactive customerGroups -->
      <v-col cols="12">
        <QCheckboxInput v-model="editItem.IsActive" :label="$t('servicesystem.common_objects.customer_group.active')"
          :externaledit="editMode" @FocusState="handleFocus">
        </QCheckboxInput>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import UsedAlert from "@/components/UsedAlert.vue";
import CustomerGroupImage from "./CustomerGroupImage.vue";

export default {
  name: "CustomerGroupEditContent",
  props: {
    originalItem: Object,
    editItem: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    CustomerGroupImage,
    UsedAlert,
  },
  mixins: [clientAPI],

  data() {
    return {
      imageKey: 1,
      used: null,
    };
  },

  mounted() { },

  methods: {
    async checkCustomerGroupId(id) {
      if (!id) {
        this.used = null;
      } else {
        await this.getCustomerGroupById(id)
          .then((response) => {
            //console.log(response);
            this.used = response;
          })
          .catch((e) => {
            if (e.status == 204) {
              this.used = null;
            }
            else {
              console.error(e)
            }
          });
      }
    },
  },

  computed: {
    isNew() {
      return this.originalItem?.Id == null;
    },

    usedConfig() {
      if (this.used) {
        return {
          message: this.$t('servicesystem.common_objects.customer_group.id_in_use', { kkey: this.$t('servicesystem.common_objects.customer_group.number'), ckey: this.used.Name }),
          openText: this.$t('servicesystem.common_objects.customer_group.view_customer_group', { ckey: this.used.Name }),
          route: { name: 'ViewCustomerGroup', params: { customerGroupId: this.used.Id } },
        };
      }
      else {
        return null;
      }
    }
  },

  watch: {
    editMode: function (newVal) {
      if (!newVal) {
        this.imageKey++;
      }
    },
  },
};
</script>


<style lang='scss'></style>